import {CATALOG_AXIOS} from "@/modules/query-history/api/backend-config";

export default {
    getAll(pageNumber, pageSize) {
        return CATALOG_AXIOS.get("/query-history", {
            params: {
                page_number: pageNumber,
                page_size: pageSize
            }
        });
    }
};
